module.exports = __webpack_public_path__ + "static/media/newimg.1cea74cf.png";